'use strict';

const LOADED_ATTR = 'ad-is-loaded';
const SHOW_AD = 'show';

const context = {
  sanitizeAd: node => {
    node.removeAttribute(LOADED_ATTR);
    node.classList.remove(SHOW_AD);
    if (node.children.length) {
      node.children[0].innerHTML = '';
    }
  },
};

module.exports = context;
